export default "__VITE_ASSET__BDXYMC7c__"